import styled from 'styled-components'

import { helpers } from 'styles'

import { ItemExpandable as DefaultItemExpandable } from 'components/Lists'

export const ItemExpandable = styled(DefaultItemExpandable)`
	margin: 0 -${helpers.spacing.large};
	width: calc(100% + ${helpers.spacing.xxLarge});

	&:last-child {
		border-bottom: 1px solid ${helpers.color.separator};
	}
`
